var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5H8.1C8.35 2.25 8.5 1.9 8.5 1.5C8.5 0.65 7.85 0 7 0C6.5 0 5.6 0.45 5 1.05C4.4 0.45 3.5 0 3 0C2.15 0 1.5 0.65 1.5 1.5C1.5 1.9 1.65 2.25 1.9 2.5H0.5C0.2 2.5 0 2.7 0 3V4.4C0 4.45 0.05 4.5 0.1 4.5H4.3C4.4 4.5 4.5 4.4 4.5 4.3V2.7C4.5 2.6 4.6 2.5 4.7 2.5H5.3C5.4 2.5 5.5 2.6 5.5 2.7V4.3C5.5 4.4 5.6 4.5 5.7 4.5H9.9C9.95 4.5 10 4.45 10 4.4V3C10 2.7 9.8 2.5 9.5 2.5ZM3 2C2.7 2 2.5 1.8 2.5 1.5C2.5 1.2 2.7 1 3 1C3.3 1 4.2 1.6 4.45 1.9C4.3 1.95 3 2 3 2ZM7 2C7 2 5.7 1.95 5.55 1.9C5.85 1.55 6.7 1 7 1C7.3 1 7.5 1.2 7.5 1.5C7.5 1.8 7.3 2 7 2Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 5.5H0.6C0.55 5.5 0.5 5.55 0.5 5.6V9.5C0.5 9.8 0.7 10 1 10H4.3C4.4 10 4.5 9.9 4.5 9.8V5.7C4.5 5.6 4.4 5.5 4.3 5.5Z",
    fill: "#8D8E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 5.5H5.7C5.6 5.5 5.5 5.6 5.5 5.7V9.8C5.5 9.9 5.6 10 5.7 10H9C9.3 10 9.5 9.8 9.5 9.5V5.6C9.5 5.55 9.45 5.5 9.4 5.5Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/menu4.52cca98ec8c1316c2b2e2601e574181f.svg";
export { ForwardRef as ReactComponent };